import CoreValue from "./CoreValue.jsx";
import FeatureDetail from "./FeatureDetail.jsx";
import CallToAction from "./CallToAction.jsx";


export default function Description() {
    return (
        <>
            <CoreValue />
            <FeatureDetail />
            <CallToAction />
        </>
    )
}